export enum AssistantAction {
    WAVING = 'waving',
    CRYING = 'crying',
}

export const getAssistantIllustration = (action?: string): string => {
    const parts = ['MMA_illu', action].filter(Boolean)
    return `/images/general/${parts.join('_')}.svg`
}

const DEFAULT_APPEARANCE = { backgroundColor: 'var(--g-blue-90)' }

const useAssistantIllustration = (assistantAction?: string) => {
    const { backgroundColor } = DEFAULT_APPEARANCE
    return { image: getAssistantIllustration(assistantAction), backgroundColor }
}

export default useAssistantIllustration
